import { Injectable } from '@angular/core';
import { ConfigGeneralService } from './config-general.service';
import { LimitesFacturasResponse, LimiteAlcanzadoResponse } from './config-general.service';
import { BehaviorSubject, Observable } from 'rxjs';

export interface LimitesFacturasState {
  limiteAlcanzado: boolean;
  cantidadIngresadas: number;
  limite: number;
  mensaje: string;
}

@Injectable({
  providedIn: 'root'
})
export class LimitesFacturasService {

  private limitesStateSubject = new BehaviorSubject<LimitesFacturasState>({
    limiteAlcanzado: false,
    cantidadIngresadas: 0,
    limite: 0,
    mensaje: ''
  });

  public limitesState$: Observable<LimitesFacturasState> = this.limitesStateSubject.asObservable();

  constructor( private configGeneralService: ConfigGeneralService ) { }


      /**
     * Verifica los límites de facturas de forma asíncrona
     */
      async verificarLimitesAsync(): Promise<LimitesFacturasState> {
        return new Promise((resolve, reject) => {
            this.configGeneralService.verificarLimitesFacturas().subscribe({
                next: (response: LimitesFacturasResponse | LimiteAlcanzadoResponse) => {
                    let state: LimitesFacturasState;
                    
                    // Verificar si es una respuesta de límite alcanzado
                    if (this.esLimiteAlcanzado(response)) {
                        const limiteResponse = response as LimiteAlcanzadoResponse;
                        state = {
                            limiteAlcanzado: true,
                            cantidadIngresadas: limiteResponse.data.cantidad_actual,
                            limite: limiteResponse.data.limite_permitido,
                            mensaje: limiteResponse.message
                        };
                    } else {
                        // Respuesta normal
                        const normalResponse = response as LimitesFacturasResponse;
                        if (normalResponse.status === 'SUCCESS' && normalResponse.data) {
                            state = {
                                limiteAlcanzado: false,
                                cantidadIngresadas: normalResponse.data.cantidad_facturas_ingresadas,
                                limite: normalResponse.data.limite,
                                mensaje: normalResponse.message
                            };
                        } else {
                            state = {
                                limiteAlcanzado: true,
                                cantidadIngresadas: 0,
                                limite: 0,
                                mensaje: normalResponse.message || 'Se ha alcanzado el límite de facturas'
                            };
                        }
                    }
                    
                    this.limitesStateSubject.next(state);
                    resolve(state);
                },
                error: (error) => {
                    console.error('Error al verificar límites de facturas:', error);
                    const state: LimitesFacturasState = {
                        limiteAlcanzado: true,
                        cantidadIngresadas: 0,
                        limite: 0,
                        mensaje: 'Error al verificar límites de facturas'
                    };
                    this.limitesStateSubject.next(state);
                    reject(error);
                }
            });
        });
    }


    /**
   * Verifica si la respuesta es de límite alcanzado
   */
    private esLimiteAlcanzado(response: LimitesFacturasResponse | LimiteAlcanzadoResponse): boolean {
        return 'data' in response && response.data !== undefined && 'cantidad_actual' in response.data;
    }
  
}
